var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
import { ModalWindow, ModalHeader, ModalFooter, ModalContent, ModalSizes, } from '../Modal/components';
import { Button } from '../Button';
import { Stack } from '../Stack';
export const Dialog = (_a) => {
    var { open = false, children, className, onClose, title, actionsLayout, negative, onPrimaryActionClick, onSecondaryActionClick, portal = true, primaryActionName, secondaryActionName, focusTrapOptions } = _a, rest = __rest(_a, ["open", "children", "className", "onClose", "title", "actionsLayout", "negative", "onPrimaryActionClick", "onSecondaryActionClick", "portal", "primaryActionName", "secondaryActionName", "focusTrapOptions"]);
    const DialogClasses = classnames('Dialog', className);
    return (React.createElement(ModalWindow, Object.assign({ className: DialogClasses, onClose: onClose, size: ModalSizes.XS, focusTrapOptions: focusTrapOptions, open: open, portal: portal, "data-anvil-component": "Dialog" }, rest),
        React.createElement(ModalHeader, { title: title, className: "Dialog__header" }),
        React.createElement(ModalContent, { className: "Dialog__content" }, children),
        React.createElement(ModalFooter, { className: "Dialog__footer" },
            React.createElement(DialogActions, { actionsLayout: actionsLayout, negative: negative, onPrimaryActionClick: onPrimaryActionClick, onSecondaryActionClick: onSecondaryActionClick, primaryActionName: primaryActionName, secondaryActionName: secondaryActionName }))));
};
const DialogActions = (props) => {
    const { actionsLayout = 'row', negative, onPrimaryActionClick, onSecondaryActionClick, primaryActionName, secondaryActionName, } = props;
    const hasPrimaryAction = !!(primaryActionName && onPrimaryActionClick);
    const hasSecondaryAction = !!(secondaryActionName && onSecondaryActionClick);
    const [primaryRect, primaryRef] = useClientRect();
    const [secondaryRect, secondaryRef] = useClientRect();
    const checkActionsWrapped = actionsLayout.includes('row') &&
        primaryRect !== null &&
        secondaryRect !== null &&
        Math.round(primaryRect.top - secondaryRect.top) !== 0; // Check whether action buttons placed on different lines
    const columnedButtons = checkActionsWrapped || actionsLayout.includes('column');
    return hasSecondaryAction && hasPrimaryAction ? (React.createElement(Stack, { alignItems: columnedButtons ? 'stretch' : null, className: columnedButtons ? 'w-100' : null, direction: checkActionsWrapped ? 'column-reverse' : actionsLayout, spacing: columnedButtons ? 1 : 2, wrap: "wrap" },
        React.createElement("span", { ref: secondaryRef },
            React.createElement(Button, { full: true, small: true, onClick: onSecondaryActionClick }, secondaryActionName)),
        React.createElement("span", { ref: primaryRef },
            React.createElement(Button, { full: true, primary: true, small: true, negative: negative, onClick: onPrimaryActionClick }, primaryActionName)))) : (React.createElement(Button, { primary: true, small: true, onClick: onPrimaryActionClick }, primaryActionName));
};
Dialog.Window = ModalWindow;
Dialog.Header = ModalHeader;
Dialog.Content = ModalContent;
Dialog.Footer = ModalFooter;
/** https://reactjs.org/docs/hooks-faq.html#how-can-i-measure-a-dom-node */
const useClientRect = () => {
    const [rect, setRect] = React.useState(null);
    const ref = React.useCallback((node) => {
        if (node !== null) {
            setRect(node.getBoundingClientRect());
        }
    }, []);
    return [rect, ref];
};
//# sourceMappingURL=Dialog.js.map